import clsx from 'clsx'
import { samplesToTc } from '../lib/timecode'

export function TimecodeDisplay({
  samples,
  fps,
  playing,
  size = 'lg',
}: {
  samples: number
  fps: number
  playing: boolean
  size?: 'md' | 'lg'
}) {
  return (
    <div
      data-testid="rt-tc-display"
      data-playing={playing || undefined}
      className={clsx(
        'font-mono tabular-nums tracking-widest',
        // v2.13: LCD timecode fixed 22px monospace at 'md'
        size === 'lg' ? 'text-4xl' : 'text-[22px]',
        playing ? 'text-[var(--text)]' : 'text-[var(--text-2)]',
      )}
      aria-label="Timecode"
    >
      {samplesToTc(samples, fps)}
    </div>
  )
}
